<template>
  <div
    class="card shadow-sm mb-4"
    v-for="section in filteredSections"
    :key="section.name"
  >
    <div
      class="card-header text-start fw-bold"
      :class="section.backgroundColor"
    >
      {{ section.name }}
    </div>
    <div class="card-body p-0">
      <div class="list-group list-group-flush text-start">
        <button
          v-for="(step, idx) in section.steps"
          :key="step.id"
          type="button"
          class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
          :class="{
            active: getCurrentStepId === step.id,
            'rounded-bottom': idx === section.steps.length - 1,
            'text-black': !step.disabled,
            'text-muted': step.disabled
          }"
          :disabled="step.disabled && !isDebugMode && isLocked"
          :aria-current="getCurrentStepId === step.id ? step.id : null"
          data-bs-dismiss="offcanvas"
          @click="setStep(step.id)"
        >
          <div class="d-flex align-items-center gap-2">
            <div>
              <i
                class="bi bi-arrow-right"
                v-if="getCurrentStepId === step.id"
              ></i>
              <i
                v-else-if="
                  getCurrentStepId !== step.id && getStepValues[step.id]
                "
                class="bi bi-check-circle"
                :class="{
                  'text-success': getCurrentStepId != step.id
                }"
              ></i>
              <i
                class="bi bi-circle"
                v-if="getCurrentStepId !== step.id && !getStepValues[step.id]"
              ></i>
            </div>
            <div>{{ step.index + 1 }}. {{ step.title }}</div>
          </div>
          <div v-if="step.disabled && isLocked">
            <i class="bi bi-lock-fill"></i>
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "TableOfContents",
  components: {},
  data() {
    return {};
  },
  props: {
    isLocked: {
      type: Boolean,
      default: true
    },
    hideComplete: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    ...mapGetters([
      "getSections",
      "getCurrentStepId",
      "getStepValues",
      "isDebugMode"
    ]),
    // Filtered sections based on hideComplete prop
    filteredSections() {
      if (!this.hideComplete) {
        return this.getSections;
      }

      // Filter out type complete steps
      let filtered = this.getSections.map((section) => {
        return {
          ...section,
          steps: section.steps.filter((step) => step.type !== "complete")
        };
      });

      // Remove sections with no steps
      filtered = filtered.filter((section) => section.steps.length > 0);

      return filtered;
    }
  },
  methods: {
    ...mapActions(["setCurrentStepId"]),

    setStep(stepId) {
      this.setCurrentStepId(stepId);

      this.$nextTick(() => {
        const el = document.getElementById(stepId);

        if (el) {
          el.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.list-group-item:hover {
  text-decoration: underline !important;
}

.active {
  background-color: rgb(230, 230, 230) !important;
  color: black !important;
  border: none !important;
}
</style>
